import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function adminHeaders() {
  // Admin auth now rides an httpOnly session cookie set by POST /api/admin/login
  // (immune to XSS token theft - JS never sees the token). Kept for call-site
  // compatibility; returns no headers.
  return {};
}
